import {
  FulfillmentGroupData,
  FulfillmentGroupPickStatus,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { OpenLikeStatuses } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";

/** A problem pick that still needs resolving; once shipped there's nothing left to resolve. */
export function isOpenProblemOrder(
  group: Pick<FulfillmentGroupData, "pickStatus" | "status">,
): boolean {
  return (
    group.pickStatus === FulfillmentGroupPickStatus.PROBLEM &&
    OpenLikeStatuses.includes(group.status)
  );
}
